import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

//component
import Banner from '../banner/banner'
import Category from './category/category'
import ProductsList from './product-list/products'
import Comment from './comment/comment'


function Products() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه محصولات</h6>
      </div>
      <div className=''>
      <Accordion  >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>تصاویر بنر صفحه محصولات</Accordion.Header>
                <Accordion.Body>
                <Banner slug="Product1"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="1">
                <Accordion.Header>گروه محصولات</Accordion.Header>
                <Accordion.Body>
                    <Category/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>محصولات</Accordion.Header>
                <Accordion.Body>
                    <ProductsList/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            <div>
              <Accordion.Item eventKey="3">
                <Accordion.Header>نظرات ثبت شده بر روی محصولات</Accordion.Header>
                <Accordion.Body>
                    <Comment/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
           
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default Products;
